import axios from "axios";
import { logout, sendOtp, updateUserProfile, verifyOtp } from "../../api";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAIL,
  UPDATE_USER_DETAILS_REQUEST,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAIL,
  CLEAR_ERRORS,
} from "../Constants/userContants";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

export const sendOTP = (email) => async (dispatch) => {
  try {
    dispatch({ type: SEND_OTP_REQUEST });

    const { data } = await sendOtp({ email });
    console.log(data);

    dispatch({ type: SEND_OTP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SEND_OTP_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const verifyOTP =
  (otp, email, hash, navigate, from) => async (dispatch) => {
    try {
      dispatch({ type: USER_LOGIN_REQUEST });

      const { data } = await verifyOtp({ otp, email, hash });

      dispatch({ type: USER_LOGIN_SUCCESS, payload: data });

      navigate(from, { replace: true });
    } catch (error) {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: error.response.data.message,
      });
    }
  };

export const logoutUser = () => async (dispatch) => {
  try {
    const { data } = await logout();
    console.log(data);

    dispatch({ type: USER_LOGOUT, payload: data });
  } catch (error) {
    dispatch({
      type: SEND_OTP_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const updateUserDetails = (details) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_DETAILS_REQUEST });

    const { data } = await updateUserProfile(details);

    dispatch({ type: UPDATE_USER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_DETAILS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
